<template>
    <modal
        :name="name"
        :width="340"
        height="auto"
        transition="nice-modal-fade"
        @before-open="beforeOpen"
    >
        <div class="modal-title">
            {{type === '7' ? '请选择学校' : '提示'}}
            <i
                class="icon iconfont icon-guanbi modal-close"
                @click="$modal.hide(name)"
            ></i>
        </div>
        <div
            v-if="type==='0'"
            class="playback-content"
        >
            <div class="playback-content__title">网页版暂不支持观看回放，请下载<span>电脑客户端</span>观看课程回放视频。</div>
            <div
                class="playback-content__download"
                @click="nowDown()"
            >
                立即下载
            </div>
        </div>
        <div
            v-if="type==='1'"
            class="live-content"
        >
            <div>
                <span>为保证您的上课体验，建议您使用</span>
                <span class="high-light">高途直播客户端</span>
                <span>观看上课视频。</span>
            </div>
            <div class="download-btn">
                <div
                    class="not-down"
                    @click="notDown()"
                >
                    暂不下载
                </div>
                <div
                    class="now-down"
                    @click="nowDown()"
                >
                    去下载
                </div>
            </div>
        </div>
        <div
            v-else-if="type==='2'"
            class="homework-content"
        >
            <p class="homework-content__title">PC端暂不支持提交练习</p>
            <p class="homework-content__title">请扫码下载APP完成提交</p>
            <img
                class="homework-content__img"
                src="~assets/img/appweima2.png"
                alt=""
            >
        </div>
        <div
            v-else-if="type==='3'"
            class="review-content"
        >
            <p class="review-content__title">PC端暂不支持查看复习内容</p>
            <p class="review-content__title">请扫码下载APP完成复习</p>
            <img
                class="review-content__img"
                src="~assets/img/appweima2.png"
                alt=""
            >
        </div>
        <div
            v-else-if="type==='4'"
            class="report-content"
        >
            <p class="report-content__title">PC端暂不支持查看学习报告</p>
            <p class="report-content__title">请扫码下载APP查看</p>
            <img
                class="report-content__img"
                src="~assets/img/appweima2.png"
                alt=""
            >
        </div>
        <div
            v-else-if="type==='5'"
            class="del-content"
        >
            <p class="del-content__prompt">确定要删除该地址？</p>
            <div class="del-content__operation">
                <div
                    class="operation-cancel"
                    @click="$modal.hide(name)"
                >
                    取消
                </div>
                <div
                    class="operation-enter"
                    @click="delAddress()"
                >
                    确定
                </div>
            </div>
        </div>
        <div
            v-else-if="type==='6'"
            class="avatar-content"
        >
            <p class="avatar-content__title">图片过大，请选择不超过2M的图片</p>
            <div
                class="avatar-content__btn"
                @click="$modal.hide(name)"
            >
                确定
            </div>
        </div>
        <div
            v-else-if="type==='7'"
            class="school-content"
        >
            <div class="form-body">
                <p class="form-body__title">请按照省、市、区选择学校</p>
                <select
                    id="s_province"
                    v-model="school_province"
                    name="select"
                    @change="handleChange(3)"
                >
                    <option
                        disabled
                        value=""
                    >
                        请选择省份
                    </option>
                    <option
                        v-for="(item, index) in school_provinces"
                        :key="index"
                        :value="item"
                    >
                        {{item}}
                    </option>
                </select>
                <select
                    id="s_city"
                    v-model="school_city"
                    name="select"
                    @change="handleChange(4)"
                >
                    <option
                        disabled
                        value=""
                    >
                        请选择城市
                    </option>
                    <option
                        v-for="(item, index) in school_citys"
                        :key="index"
                        :value="item"
                    >
                        {{item}}
                    </option>
                </select>
                <select
                    id="s_town"
                    v-model="school_area"
                    name="select"
                    @change="handleChange(5)"
                >
                    <option
                        disabled
                        value=""
                    >
                        请选择区县
                    </option>
                    <option
                        v-for="(item, index) in school_areas"
                        :key="index"
                        :value="item"
                    >
                        {{item}}
                    </option>
                </select>
                <select
                    id="s_school"
                    v-model="school_name"
                    name="select"
                    @change="handleChange(6)"
                >
                    <option
                        disabled
                        value=""
                    >
                        请选择学校
                    </option>
                    <option
                        v-for="(item, index) in school_names"
                        :key="index"
                        :value="item"
                    >
                        {{item}}
                    </option>
                </select>
                <div
                    v-if="!isFetching"
                    class="form-body__commit"
                    @click="updateSchool()"
                >
                    确定
                </div>
                <div
                    v-else
                    class="form-body__commiting"
                >
                    修改中...
                </div>
            </div>
        </div>
        <div
            v-else-if="type==='8'"
            class="live-content"
        >
            <div>
                <span>为了给您提供更加稳定、流畅和完整的上课体验，请使用</span>
                <span class="high-light">高途直播客户端</span>
                <span>上课。</span>
            </div>
            <div
                v-if="!onlyOpenClient"
                class="download-btn"
            >
                <div
                    class="not-down"
                    @click="dontOpen()"
                >
                    暂不打开
                </div>
                <div
                    class="now-down"
                    @click="openNow()"
                >
                    打开客户端
                </div>
            </div>
            <div
                v-else
                class="open-client"
            >
                <div
                    class="btn"
                    @click="openNow()"
                >
                    打开客户端
                </div>
            </div>
        </div>
        <div
            v-else-if="type==='9'"
            class="avatar-content"
        >
            <p class="avatar-content__title">本浏览器暂不支持打开高途客户端，请使用Chrome或360极速浏览器打开</p>
            <div
                class="avatar-content__btn"
                @click="$modal.hide(name)"
            >
                确定
            </div>
        </div>
    </modal>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import {mapGetters, mapState} from 'vuex';
import Vue from 'vue';
import qs from 'qs';
import {provinceJson, launchCustomProtocol} from '@base/util/common';
import api from '~/api';
import config from '~/environment';
import Cookies from 'js-cookie';

let habo = null;
if (process.browser) {
    habo = require('habo');
    Vue.use(habo);
}

export default {
    props: {
        // eslint-disable-next-line vue/require-default-prop
        name: String,
        // eslint-disable-next-line vue/require-default-prop
        type: String,
        callback: Function,
    },
    data() {
        return {
            live_id: '',
            live_status: 20,
            id: 0,
            school_provinces: provinceJson.province,
            school_citys: [],
            school_areas: [],
            school_names: [],
            school_province: '',
            school_city: '',
            school_area: '',
            school_name: '',
            isFetching: false,
            onlyOpenClient: false
        };
    },
    computed: {
        ...mapState({
            sid: state => state.token
        })
    },
    methods: {
        beforeOpen(e) {
            if (this.type === '1' || this.type === '8') {
                this.live_id = e.params.live_id || '';
                // eslint-disable-next-line no-magic-numbers
                this.live_status = e.params.live_status || 20;
                this.live_type = typeof e.params.live_type === 'undefined' ? 1000 : e.params.live_type;
                this.onlyOpenClient = e.params.onlyOpenClient;
            }
            else if (this.type === '5') {
                this.id = e.params.address_id;
            }
        },
        notDown() {
            // eslint-disable-next-line no-magic-numbers
            if (this.live_status === 21) {
                this.$store.dispatch('GET_LIVE_URL', {
                    live_id: this.live_id
                });
            }
            else if (this.live_type === 1) {
                this.$store.dispatch('GET_PLAYBACK_URL', {
                    liveId: this.live_id
                });
            }
            else if (this.live_type === 0) {
                this.$router.push({path: `/video/${this.live_id}`});
            }
        },
        nowDown() {
            window.location.href = this.detectOS();
        },
        delAddress() {
            this.$modal.hide(this.name);
            this.$emit('delAddress', this.id);
        },
        detectOS() {
            const isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Windows');
            const isMac
                = (navigator.platform === 'Mac68K')
                    || (navigator.platform === 'MacPPC')
                    || (navigator.platform === 'Macintosh')
                    || (navigator.platform === 'MacIntel');
            if (isMac) {
                return 'https://www.wenzaizhibo.com/default/home/liveclientDownload?partner_id=49752473&type=mac';
            }
            if (isWin) {
                return 'https://www.wenzaizhibo.com/default/home/liveclientDownload?partner_id=49752473&type=windows_7';
            }
            if (!isWin && !isMac) {
                this.$router.push({path: '/download'});
            }
        },
        handleChange(type) {
            switch (type) {
                case 3:
                    this.school_citys = provinceJson[this.school_province];
                    this.school_city = '';
                    this.school_area = '';
                    this.school_areas = [];
                    break;
                case 4:
                    this.school_areas = provinceJson[this.school_city];
                    this.school_area = '';
                    break;
                case 5:
                    // eslint-disable-next-line no-case-declarations
                    const params = {
                        province: this.school_province,
                        city: this.school_city,
                        area: this.school_area
                    };
                    this.$axios.$get(api.user.school, {
                        params
                    }).then(res => {
                        if (res.status === 0 && res.data) {
                            this.school_names = res.data.schoolNameList;
                        }
                    });
                    break;
                default:
                    break;
            }
        },
        updateSchool() {
            if (this.school_name !== '') {
                const params = {
                    school: this.school_name
                };
                this.isFetching = true;
                this.$axios.$post(api.user.updateProfile, qs.stringify(params)).then(res => {
                    if (res.code === 0) {
                        this.$axios.$get(api.user.profile).then(res => {
                            const {code, data = {}} = res;
                            if (code === 0) {
                                this.$store.commit('USER_INFO', data);
                                this.$modal.hide('school');
                                this.isFetching = false;
                                this.callback && this.callback(this.school_name);
                            }
                        });
                    }
                });
            }
        },
        // 打开直播间
        dontOpen() {
            switch (this.live_status) {
                case 21:
                    this.$store.dispatch('GET_LIVE_URL', {
                        live_id: this.live_id
                    });
                    break;
                case 26:
                    this.$store.dispatch('GET_PLAYBACK_URL', {
                        liveId: this.live_id
                    });
                    break;
                default:
                    break;
            }
        },
        // 打开高途直播客户端
        openNow() {
            if (this.live_status === 21) {
                const params = {
                    liveId: this.live_id
                };
                this.$axios.$post(api.live.login_web, qs.stringify(params)).then(res => {
                    if (res.code === 0) {
                        this.reportHandle(
                            {
                                room_number: res.data.roomId,
                                type: 1,
                                big_room_number: res.data.roomNumber
                            }
                        );
                        const clientUrl = `${res.data.jumpClientUrl}&ts=`;
                        const isSupported = launchCustomProtocol(clientUrl);
                        if (!isSupported) {
                            this.$modal.hide('toApp');
                            this.$modal.show('otherBrowser');
                        }
                    }
                });
            }
            if (this.live_status === 26) {
                const params = {
                    liveId: this.live_id
                };
                this.$axios.$post(api.live.playback, qs.stringify(params)).then(res => {
                    if (res.code === 0) {
                        this.reportHandle({big_room_number: res.data.signinLivePlayback.roomId, type: 3});
                        const clientUrl = `${res.data.signinLivePlayback.jumpClientUrl}&ts=`;
                        const isSupported = launchCustomProtocol(clientUrl);
                        if (!isSupported) {
                            this.$modal.hide('toApp');
                            this.$modal.show('otherBrowser');
                        }
                    }
                });
            }
        },
        reportHandle(param) {
            const userInfo = Cookies.get('__user_info__') ? JSON.parse(Cookies.get('__user_info__')) : '';
            const user_number = userInfo.userNumber || '';
            const {room_number = '', type, big_room_number = ''} = param;
            const reportParams = {
                infoType: 85,
                partnerId: config.env.partnerId,
                userNumber: user_number,
                clientType: 0,
                time: new Date().getTime(),
                deviceId: '',
                pcVersion: '',
                appVersion: '',
                sdkVersion: '',
                type,
                roomNumber: room_number,
                bigRoomNumber: big_room_number,
                fid: '',
                userId: '',
                watchNumber: '',
                useUdp: '',
                ls: '',
                cdn: '',
                cdnTag: '',
                step: 0,
                timeStamp: new Date().getTime(),
                playIndex: new Date().getTime(),
            };
            // eslint-disable-next-line no-undef
            habo.default.setConfig({deviceOS: 'Mojave', devicePlatform: 'Mac'});
            // eslint-disable-next-line no-undef
            habo.default.video({event_attr: reportParams});
        }
    }
};
</script>

<style lang="less" scoped>
.modal-title {
    position: relative;
    font-size: 20px;
    color: #32404b;
    padding: 30px 0 20px;
    text-align: center;

    .modal-close {
        position: absolute;
        top: 15px;
        right: 15px;
        cursor: pointer;
    }
}

.playback-content {
    margin: 0 30px;
    text-align: center;

    &__title {
        font-size: 20px;
        color: #32404b;
        line-height: 30px;
        border-top: 1px dashed #ddd;
        padding-top: 20px;
        text-indent: 2em;
        text-align: left;

        span {
            color: #f63232;
        }
    }

    &__download {
        display: inline-block;
        width: 130px;
        height: 44px;
        line-height: 44px;
        background-color: #f63232;
        color: #fff;
        border-radius: 4px;
        font-size: 20px;
        margin-top: 10px;
        margin-bottom: 30px;
        cursor: pointer;
    }
}

.live-content {
    user-select: none;
    margin: 0 26px;
    border-top: 1px dashed #ddd;
    padding-top: 20px;
    font-size: 20px;
    line-height: 30px;

    .high-light {
        color: #f63232;
    }

    .not-down {
        width: 130px;
        padding: 12px 0;
        border: 1px solid #f63232;
        color: #f63232;
        text-align: center;
        text-indent: 0;
        border-radius: 4px;
        float: left;
        margin-top: 20px;
        margin-bottom: 30px;
        user-select: none;
        cursor: pointer;
        box-sizing: border-box;
    }

    .now-down {
        width: 130px;
        padding: 12px 0;
        background-color: #f63232;
        color: #fff;
        text-indent: 0;
        text-align: center;
        border: 1px solid #f63232;
        float: right;
        border-radius: 4px;
        margin-top: 20px;
        margin-bottom: 30px;
        user-select: none;
        cursor: pointer;
        box-sizing: border-box;
    }

    .download-btn {
        height: 106px;
    }

    .open-client {
        position: relative;
        padding: 20px 0 26px;

        .btn {
            position: relative;
            height: 44px;
            line-height: 44px;
            background: #f63232;
            border-radius: 4px;
            font-size: 20px;
            text-align: center;
            color: #fff;
            cursor: pointer;
        }
    }
}

.homework-content,
.review-content,
.report-content,
.avatar-content {
    user-select: none;
    margin: 0 30px;
    border-top: 1px dashed #ddd;
    padding-top: 20px;
    font-size: 20px;
    text-align: center;

    &__title {
        line-height: 25px;
        color: #f63232;
        margin: 0;
    }

    &__img {
        margin-top: 22px;
        margin-bottom: 44px;
        width: 164px;
        height: 164px;
    }
}

.avatar-content__title {
    color: #32404b;
    font-size: 20px;
    margin-bottom: 20px;
}

.avatar-content__btn {
    display: inline-block;
    width: 130px;
    height: 44px;
    line-height: 44px;
    border-radius: 4px;
    background-color: #f63232;
    color: #fff;
    margin-bottom: 30px;
    cursor: pointer;
}

.del-content {
    user-select: none;
    margin: 0 30px 10px;
    border-top: 1px dashed #ddd;
    padding-top: 20px;
    font-size: 20px;
    text-indent: 2em;
    line-height: 30px;

    &__prompt {
        text-indent: 0;
        text-align: center;
        margin: 0;
    }

    &__operation {
        text-align: right;
        margin-top: 20px;

        .operation-cancel {
            width: 130px;
            height: 44px;
            line-height: 44px;
            text-indent: 0;
            text-align: center;
            color: #f63232;
            border: 1px solid #f63232;
            cursor: pointer;
            border-radius: 4px;
            float: left;
            margin-bottom: 30px;
        }

        .operation-enter {
            width: 130px;
            height: 44px;
            line-height: 44px;
            text-indent: 0;
            text-align: center;
            color: #fff;
            cursor: pointer;
            border-radius: 4px;
            border: 1px solid #f63232;
            background-color: #f63232;
            float: right;
            margin-bottom: 30px;
        }
    }
}

.school-content {
    .form-head {
        padding: 0 20px;
        height: 50px;
        line-height: 50px;
        background-color: #f5f7fa;
        color: #a5a5a5;

        .close {
            float: right;
        }
    }

    .form-body {
        padding: 5px 22px 22px;
        background-color: #fff;

        select {
            width: 100%;
            height: 44px;
            background-color: #fff;
            border-radius: 4px;
            border: solid 1px #ebebeb;
            color: #a7b0b8;
            outline: none;
            margin-bottom: 15px;
        }

        &__commit,
        &__commiting {
            width: 120px;
            height: 40px;
            line-height: 40px;
            color: #fff;
            margin: 0 auto;
            font-size: 16px;
            background-color: #f63232;
            text-align: center;
            border-radius: 4px;
            cursor: pointer;
        }

        &__commiting {
            background-color: #d63131;
            cursor: not-allowed;
        }
    }
}
</style>
